module.exports = __webpack_public_path__ + "media/components/nearby-points/static/photo-10-c282e40ead25d3bf188908adc0aa1241.jpg";